module.exports = __webpack_public_path__ + "img/soar.86e7969c.png";